import { t } from "@bezbolisno/i18n";
import { createFileRoute } from "@tanstack/react-router";
import { LoadErrorScreen } from "../../screens/invoices/shared";
import { ProfileScreen } from "../../screens/profile/profile-screen";
import { sessionsQuery } from "../../screens/profile/queries";

/** Every staff role has a profile — no `can()` gate. The sessions list is only prefetched: a
 *  failing list must not take the name and password forms down with it. */
export const Route = createFileRoute("/_authed/profile")({
  loader: ({ context }) => context.queryClient.prefetchQuery(sessionsQuery),
  errorComponent: () => <LoadErrorScreen title={t.profile.title} />,
  component: () => {
    const { session } = Route.useRouteContext();
    return <ProfileScreen session={session} />;
  },
});
